import { render, staticRenderFns } from "./ProgressBarsPage.vue?vue&type=template&id=366a955e&scoped=true&"
import script from "./ProgressBarsPage.vue?vue&type=script&lang=js&"
export * from "./ProgressBarsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366a955e",
  null
  
)

export default component.exports